import Decimal from 'decimal.js';

export const preventDefault = (e: any) => {
  e.preventDefault();
};

export const stopPropagation = (e: any) => {
  e.stopPropagation();
};

export const budgetPercentageCal = (remainingBudgetAmount: number, budgetAmount: number) =>
  Number(budgetAmount) === 0
    ? 0
    : round((Number(remainingBudgetAmount) / Number(budgetAmount)) * 100, 2) > 100
    ? 100
    : round((Number(remainingBudgetAmount) / Number(budgetAmount)) * 100, 2);

export const getBackgroundColor = (value: string) => {
  if (Number(value) < 0) {
    return { backgroundColor: '#94c94747' };
  }
  return {};
};

export function lastIndex<T>(array: T[], fn: (element: T) => boolean): number {
  for (let i = array.length - 1; i >= 0; i--) {
    if (fn(array[i])) {
      return i;
    }
  }
  return -1;
}

export const percentageCal = (percentageAmount: number, amt: number) =>
  round(Number(percentageAmount || 0) * 0.01 * Number(amt || 0), 2);

export function calculatePercentage(total: number, value: number) {
  let percentage = (value / total) * 100;
  return round(percentage, 2);
}

export const isFirefoxBrowser = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

export const isNullOrUndefined = (value: any) => value === null || value === undefined;

export const isTrue = (value: any) => value === true;
export const isFalse = (value: any) => value === false;

export function round(num: number, precision = 0) {
  let x = new Decimal(num || 0);
  return x.toDecimalPlaces(5).toDecimalPlaces(precision).toNumber();
}
